import { useQueryClient } from '@tanstack/vue-query';
import type { RouteLocationNormalized } from 'vue-router';

import { profileQueryOptions } from '@/entities/profile';
import { projectKeys, projectQueryOptions } from '@/entities/project';

import { isFeatureAvailable } from './feature-guard';

export const beforeEach = async (to: RouteLocationNormalized) => {
  const queryClient = useQueryClient();

  try {
    const isProfileNeeded = to.matched.some((record) => record.meta.profile);

    if (isProfileNeeded) {
      const profile = await queryClient.ensureQueryData(profileQueryOptions());

      if (!isFeatureAvailable(profile, to)) {
        return { name: '404' };
      }

      // Redirect to the default project if the user is trying to access the default project
      if (to.params.project_uuid === 'default') {
        const project = await queryClient.ensureQueryData(projectQueryOptions());

        queryClient.setQueryData(projectKeys.project(), project);

        return { name: 'project', params: { project_uuid: project.uuid } };
      }
    }
  } catch {
    queryClient.clear();
    return { name: 'login' };
  }
};
